import axios from "./axios";
import { call, put, takeLatest, spawn } from "redux-saga/effects";
import { CLAIM_REWARD_REQUEST, GET_REWARD_STATUS_REQUEST } from "../types";
import { clientErrorMessage, delay } from "./reusable";
import {
  claimRewardFailure,
  claimRewardLoading,
  claimRewardSuccess,
  getRewardStatusFailure,
  getRewardStatusLoading,
  getRewardStatusSuccess,
  getLogUserRequest,
} from "../action";

const ajaxDBCalls = {
  claimReward: async () => {
    const response = await axios.post(`/reward/claim`);
    return response;
  },
  getRewardStatus: async () => {
    const response = await axios.get(`/reward/status`);
    return response;
  },
};

function* claimReward({ payload }) {
  try {
    yield put(claimRewardLoading(true));

    const res = yield call(ajaxDBCalls.claimReward, payload);

    yield put(claimRewardSuccess(res.data));

    // Refresh user data to update balance
    if (payload?.token) {
      yield put(getLogUserRequest(payload.token));
    }

    yield put(claimRewardLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      const { message } = err.response.data;
      errorMessage =
        typeof message === "string" ? message : JSON.stringify(message);
    }

    yield put(claimRewardFailure(errorMessage));
    yield put(claimRewardLoading(false));
    yield delay();
    yield put(claimRewardFailure(""));
  }
}

function* getRewardStatus({ payload }) {
  try {
    yield put(getRewardStatusLoading(true));

    const res = yield call(ajaxDBCalls.getRewardStatus, payload);

    yield put(getRewardStatusSuccess(res.data));

    yield put(getRewardStatusLoading(false));
  } catch (err) {
    let errorMessage = "";
    if (err.request) errorMessage = clientErrorMessage;

    if (err.response) {
      const { message } = err.response.data;
      errorMessage =
        typeof message === "string" ? message : JSON.stringify(message);
    }

    yield put(getRewardStatusFailure(errorMessage));
    yield put(getRewardStatusLoading(false));
    yield delay();
    yield put(getRewardStatusFailure(""));
  }
}

// Watchers
function* claimRewardWatcher() {
  yield takeLatest(CLAIM_REWARD_REQUEST, claimReward);
}

function* getRewardStatusWatcher() {
  yield takeLatest(GET_REWARD_STATUS_REQUEST, getRewardStatus);
}

export default function* rewardSagas() {
  yield spawn(claimRewardWatcher);
  yield spawn(getRewardStatusWatcher);
}
